import React, { Component } from 'react';

import Button from 'components/common/Button/Button';
import Checkbox from 'components/common/Checkbox/Checkbox';

import cn from 'classnames';
import styles from './Sea.scss';
import tracker from '../../../../../services/tracker';
import { withTranslation } from 'react-i18next';
import i18n from '../../../../../i18n';

const variants = {
  500: { param: '500', key: '500', text: i18n.t('components.header.filtersBar.filters.sea.500'), event: 'Web_Filters_Up_To_500' },
  1500: { param: '1500', key: '1500', text: i18n.t('components.header.filtersBar.filters.sea.1500'), event: 'Web_Filters_Up_To_1500' },
  3000: { param: '3000', key: '3000', text: i18n.t('components.header.filtersBar.filters.sea.3000'), event: 'Web_Filters_Up_To_3000' }
};

export const parseSearch = (search) => {
  const { sea } = search;
  return { sea };
};

export const compileSearch = (data) => {
  const { sea } = data;
  return { sea };
};

export const compileRequest = (data) => {
  const { sea } = data;
  return { distanceToSea: sea };
};

export const getRequest = (search) => compileRequest(parseSearch(search));

export const subtext = (search) => {
  const { sea } = parseSearch(search);
  return (sea && sea.text) || i18n.t('components.header.filtersBar.filters.sea.notSelected');
};

class Sea extends Component {

  constructor(props) {
    super(props);

    this.handleCheckboxClick = this.handleCheckboxClick.bind(this);
    this.handleClearClick = this.handleClearClick.bind(this);
  }

  handleClearClick() {
    const { dropdownData } = this.props;
    const data = { sea: undefined };
    const compiledSearch = compileSearch(data);
    const compiledRequest = compileRequest(data);
    dropdownData(compiledSearch, compiledRequest);
    this.props.onClearClick('sea');
  }

  handleCheckboxClick(key, checked) {
    const { dropdownData, eventData } = this.props;
    const data = { sea: checked ? key : undefined };

    tracker.sendVariantEvent({ variants, key, selected: checked, eventData });

    const compiledSearch = compileSearch(data);
    const compiledRequest = compileRequest(data);
    dropdownData(compiledSearch, compiledRequest);
  }

  checkbox(key) {
    const { search, additional } = this.props;
    const { sea } = parseSearch(search);
    const variant = variants[key];
    return (
      <Checkbox
        className={styles.Checkbox}
        innerStyle={styles.FiltersCheckInner}
        classNameClone="CheckboxCloneFilters"
        checked={sea === key}
        type="radio"
        additional={additional}
        handle={this.handleCheckboxClick.bind(undefined, variant.key)}
        text={variant.text}
      />
    );
  }

  render() {
    const { className, additional, search, t } = this.props;
    const { sea } = parseSearch(search);

    return (
      <div className={cn(styles.Menu, className, { [styles.Additional]: additional })}>
        <p className={styles.Title}>
          {t('components.header.filtersBar.filters.sea.title')}
          {!additional ? (
              !!sea &&
              <Button className={styles.Button} onClick={this.handleClearClick}>
                {t('components.header.filtersBar.filters.sea.clear')}
              </Button>
          ) : (null)}
        </p>
        <div className={styles.Checkboxes}>
          <div className={styles.FirstColumn}>
            {this.checkbox('500')}
          </div>
          <div className={styles.SecondColumn}>
            {this.checkbox('1500')}
          </div>
          <div className={styles.ThirdColumn}>
            {this.checkbox('3000')}
          </div>
        </div>
        {additional ? (
          <div className={styles.ButtonWrap}>
            {!!sea &&
              <Button className={styles.Button} onClick={this.handleClearClick}>
                {t('components.header.filtersBar.filters.sea.clear')}
              </Button>}
          </div>
        ) : (null)}
      </div>
    );
  }
}

export default withTranslation()(Sea);



// WEBPACK FOOTER //
// ./src/components/Header/FiltersBar/Filters/Sea/Sea.js